import React, { useState, useRef } from "react";
import { Grid, Input, MenuItem, Select, InputLabel, Typography, Chip } from "@mui/material";
import Box from '@mui/material/Box';
import CountrySelect from "../../../CountrySelect";
import TextField from '@mui/material/TextField';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import * as dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Paper from "@mui/material/Paper";
import { Uploader } from "uploader";
import { UploadButton } from "react-uploader";
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import LangageSelect from "../../../LangageSelect";
import NationalitySelect from "../../../NationalitySelect";
import { setMainConfig } from "@cyntler/react-doc-viewer/dist/esm/store/actions";
import { MyButtonComponent, MyDropzoneComponent } from "../../../FileUploader";
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Avatar from '@mui/material/Avatar';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { height } from "@mui/system";
import DownloadIcon from '@mui/icons-material/Download';
import { trainingPrograms } from "./trainingPrograms";

const StudentDetails = ({
    setFirstName, firstNameValue,
    setLastName, lastNameValue,
    setGender, genderValue,
    setNationality, nationalityValue,
    setAddress, addressValue,
    setAddress2, address2Value,
    setLocality, localityValue,
    setCountry, countryValue,
    setBirthDate, birthDateValue,
    setMotherTongue, motherTongueValue,
    setEmail, emailValue,
    setPassport, passportValue,
    setAddress3, address3Value,
    setZipCode, zipCodeValue,
    setPhone, phone,
    setAgeGroup, ageGroup,
    isFormInvalid,
    hideTitle,
    center,
    setCountryName,
    readonly,
    setProfilePicture, profilePicture,
    setPassportPicture, passportPicture,
    setLevel, level,
    userType
}) => {

    const handleNationalitySelect = (newValue) => {
        setCountry(newValue);
        setNationality(newValue);
        setMotherTongue(newValue);
    }

    const ageGroupsByCenter = {
        'ST': [
            { value: 1, label: 'Teens (10-12)', minAge: 10, maxAge: 12 },
            { value: 2, label: 'Juniors (13-15)', minAge: 13, maxAge: 15 },
            { value: 3, label: 'Seniors (16+)', minAge: 16 },
        ],
        'QW': [
            { value: 0, label: 'Kids (6-9)', minAge: 6, maxAge: 9 },
            { value: 1, label: 'Teens (10-12)', minAge: 10, maxAge: 12 },
            { value: 2, label: 'Juniors (13-15)', minAge: 13, maxAge: 15 },
            { value: 3, label: 'Seniors (16+)', minAge: 16 },
        ],
        'VA': [
            { value: 1, label: 'Juniors (10-14)', minAge: 10, maxAge: 14 },
            { value: 3, label: 'Seniors (15-17)', minAge: 15, maxAge: 17 },
        ],
        'PA': [
            { value: 1, label: 'Juniors (10-14)', minAge: 10, maxAge: 14 },
            { value: 3, label: 'Seniors (15-17)', minAge: 15, maxAge: 17 },
        ]
    };

    const HandleBirthDateChange = (birthDate) => {
        var finalAge
        const _weeks = center.weeks.filter((w) => w.weekNumber == 1);

        if (!_weeks || _weeks.length <= 0) {
            finalAge = calculerAge(new Date(birthDate), new Date())
        } else {
            finalAge = calculerAge(new Date(birthDate), new Date(_weeks[_weeks.length - 1].startDate))
        }

        if (center.currency == 1) {
            if (center && center.abbreviation && ageGroupsByCenter[center.abbreviation]) {
                const ageGroup = ageGroupsByCenter[center.abbreviation].find(group => {
                    if (group.minAge && group.maxAge) {
                        return finalAge >= group.minAge && finalAge <= group.maxAge;
                    } else if (group.minAge) {
                        return finalAge >= group.minAge;
                    } else {
                        return { value: null, label: '' };
                    }
                });


                if (ageGroup) {
                    setAgeGroup(ageGroup.value);
                } else {
                    setAgeGroup(null);
                }
            } else {
                setAgeGroup(null);
            }

        } else {
            const hasValidProgram = trainingPrograms.some((tp, index) => {
                const priceIsValid = (() => {
                    switch (index) {
                        case 0: return center.trainingProgramPrice1 > 0;
                        case 1: return center.trainingProgramPrice2 > 0;
                        case 2: return center.trainingProgramPrice3 > 0;
                        case 3: return center.trainingProgramPrice4 > 0;
                        default: return false;
                    }
                })();
            
                if (priceIsValid && tp.min <= finalAge && tp.max >= finalAge) {
                    return true; 
                }
                return false; 
            });
            
            if (!hasValidProgram) {
                setAgeGroup(null);
            } else {
                setAgeGroup(-1);
            }
        }

        setBirthDate(birthDate);
    };

    function calculerAge(birthDate, refDate) {

        var age = refDate.getFullYear() - birthDate.getFullYear();
        var m = refDate.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && refDate.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const handleImageChange = async (event) => {
        var file = event.target.files[0]
        if (file) {
            setProfilePicture(await toBase64(file));
        }
    };

    const downloadPassport = (passport) => {
        var link = document.createElement("a");
        link.download = `${firstNameValue}_${lastNameValue}_passport.pdf`;
        link.href = passportPicture;
        document.body.appendChild(link);
        link.click();
    }

    const handlePassportPictureChange = async (event) => {
        var file = event.target.files[0]
        if (file) {
            setPassportPicture(await toBase64(file));
        }
    };

    return (
        <Paper elevation={3} display="flex" className={"step-container"}>
            <Box sx={{ color: 'primary.main' }}>
                {!hideTitle ?
                    <Typography fontSize={20} fontWeight={'bold'} marginBottom={2} marginTop={2} align="left">
                        Student Details
                    </Typography> : <></>}
            </Box>

            <Box sx={{ color: 'primary.main_light' }} align="right">
                <label htmlFor="passport">{'Student picture'}</label>
                <br></br>
                {profilePicture ?
                    <div>
                        <Grid container>
                            <Grid item xs={12}>
                                <Avatar sx={{ height: "100px", width: "100px" }}>
                                    <img src={profilePicture} height={100} width={100} />
                                </Avatar>

                            </Grid>
                            <Grid item xs={12} alignItems={"center"}>
                                {!readonly &&
                                    <IconButton variant="contained" component="label" onClick={() => { setProfilePicture(null) }} >
                                        <DeleteIcon />
                                    </IconButton >
                                }
                            </Grid>

                        </Grid>
                    </div>
                    :

                    <>
                        {!readonly &&
                            <><IconButton variant="contained" component="label">
                                <Avatar sx={{ height: "100px", width: "100px" }}>
                                    <AddAPhotoIcon />
                                    <input type="file" hidden accept=".png,.gif,.jpg,.jpeg" max={3 * 1024 * 1024} onChange={handleImageChange} />
                                </Avatar>
                            </IconButton >
                                <br></br>
                                <Typography fontSize={10}>
                                    Allowed *.jpg, *.jpeg, *.png, *.gif
                                </Typography>
                                <Typography fontSize={10}>
                                    Max size of 3 MB
                                </Typography>
                            </>}
                    </>
                }
                <br></br>
            </Box>


            <Box sx={{ color: 'primary.main_light' }}>
                <Typography fontSize={17} fontWeight={'bold'} marginBottom={1} marginTop={1} align="left">
                    Basic Information
                </Typography>
            </Box>
            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                <Grid item xs={6}>
                    <label htmlFor="firstname">First Name *</label>
                    <TextField
                        type="text"
                        error={isFormInvalid && (firstNameValue == "" || firstNameValue == null)}
                        size="small"
                        className="form-control"
                        name="firstname"
                        disabled={readonly}
                        value={firstNameValue}
                        onChange={(e) => setFirstName(e.target.value)}
                        inputProps={{ maxLength: 50 }}
                    />
                </Grid>
                <Grid item xs={6} >
                    <label htmlFor="firstname">Last Name *</label>
                    <TextField
                        type="text"
                        error={isFormInvalid && (lastNameValue == "" || lastNameValue == null)}
                        size="small"
                        className="form-control"
                        name="lastname"
                        disabled={readonly}
                        value={lastNameValue}
                        onChange={(e) => setLastName(e.target.value)}
                        inputProps={{ maxLength: 50 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <TextField
                            size="small"
                            type="email"
                            className="form-control"
                            disabled={readonly}
                            name="email"
                            value={emailValue}
                            onChange={(e) => setEmail(e.target.value)}
                            inputProps={{ maxLength: 250 }}
                        />
                    </div>
                </Grid>

                <Grid item xs={3}>
                    <div className="form-group">
                        <label htmlFor="passport">{center.currency == 1 ? 'Passport/eID Number *' : 'Passport Number *'}</label>
                        <TextField
                            size="small"
                            type="text"
                            error={isFormInvalid && (passportValue == "" || passportValue == null)}
                            className="form-control"
                            name="passport"
                            disabled={readonly}
                            value={passportValue}
                            onChange={(e) => setPassport(e.target.value)}
                            inputProps={{ maxLength: 150 }}
                        />
                    </div>
                </Grid>

                <Grid item xs={3}>
                    <div className="form-group">
                        <label htmlFor="phone">Phone *</label>
                        <TextField
                            size="small"
                            type="phone"
                            error={isFormInvalid && (phone == "" || phone == null)}
                            className="form-control"
                            name="phone"
                            disabled={readonly}
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            inputProps={{ maxLength: 150 }}
                        />
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <label htmlFor="gender">Gender</label>
                    <Select
                        size="small"
                        labelId="gender"
                        name="gender"
                        align="left"
                        disabled={readonly}
                        value={genderValue}
                        style={{ minWidth: '100%', background: "white" }}
                        onChange={(e) => setGender(e.target.value)}>

                        <MenuItem value={1}>Male</MenuItem>
                        <MenuItem value={2}>Female</MenuItem>
                        <MenuItem value={3}>Other</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={6}>
                    <div className="form-group">
                        <label htmlFor="country">Nationality</label>
                        <NationalitySelect setValue={handleNationalitySelect} readonly={readonly} selectedCode={nationalityValue} />
                    </div>
                </Grid>

                <Grid item xs={6}>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            inputFormat="DD/MM/YYYY"
                            value={birthDateValue}
                            maxDate={new Date()}
                            minDate={dayjs(new Date()).subtract(18, 'year')}
                            onChange={HandleBirthDateChange}
                            disabled={readonly}
                            renderInput={(params) =>
                                <>
                                    <label htmlFor="birthdate">Birthday *</label>
                                    <br></br>
                                    <TextField sx={{ width: '100%', backgroundColor: 'white' }}
                                        size="small"
                                        {...params}
                                        helperText={birthDateValue && isFormInvalid && (ageGroup == null) ? "The age of the student does not correspond to any age group of the centre" : ""}
                                        error={isFormInvalid && (ageGroup == null)} />
                                </>
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={!hideTitle ? 6 : 4}>
                    <div className="form-group">
                        <label htmlFor="motherTongue">Mother tongue</label>
                        <LangageSelect setValue={setMotherTongue} readonly={readonly} selectedCode={motherTongueValue} />
                    </div>
                </Grid>
                {hideTitle ?
                    <Grid item xs={2}>
                        <label htmlFor="gender">Level of {center.currency == 1 ? "French" : "English"}</label>
                        <Select
                            size="small"
                            labelId="gender"
                            name="gender"
                            align="left"
                            disabled={readonly || userType != 1}
                            value={level}
                            style={{ minWidth: '100%', background: "white" }}
                            onChange={(e) => setLevel(e.target.value)}>
                            <MenuItem value={null}></MenuItem>
                            <MenuItem value={1}>A1</MenuItem>
                            <MenuItem value={2}>A2</MenuItem>
                            <MenuItem value={3}>B1</MenuItem>
                            <MenuItem value={4}>B2</MenuItem>
                            <MenuItem value={5}>C1</MenuItem>
                            <MenuItem value={6}>C2</MenuItem>
                        </Select>
                    </Grid> : <></>
                }
            </Grid>
            <Box sx={{ color: 'primary.main_light' }}>
                <Typography fontSize={17} fontWeight={'bold'} marginTop={3} align="left">
                    Address
                </Typography>
            </Box>
            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                <Grid item xs={12} />
                <Grid item xs={5}>
                    <div className="form-group">
                        <label htmlFor="address">Address</label>
                        <TextField
                            size="small"
                            type="text"
                            disabled={readonly}
                            className="form-control"
                            name="address"
                            value={addressValue}
                            onChange={(e) => setAddress(e.target.value)}
                            inputProps={{ maxLength: 150 }}
                        />
                    </div>
                </Grid>
                <Grid item xs={4}>
                    <div className="form-group">
                        <label htmlFor="address2">Address line 1</label>
                        <TextField
                            size="small"
                            type="text"
                            disabled={readonly}
                            className="form-control"
                            name="address2"
                            value={address2Value}
                            onChange={(e) => setAddress2(e.target.value)}
                            inputProps={{ maxLength: 100 }}
                        />
                    </div>
                </Grid>
                <Grid item xs={3}>
                    <div className="form-group">
                        <label htmlFor="address3">Address line 2</label>
                        <TextField
                            size="small"
                            type="text"
                            disabled={readonly}
                            className="form-control"
                            name="address3"
                            value={address3Value}
                            onChange={(e) => setAddress3(e.target.value)}
                            inputProps={{ maxLength: 50 }}
                        />
                    </div>
                </Grid>
                <Grid item xs={5}>
                    <div className="form-group">
                        <label htmlFor="country">Country </label>
                        <CountrySelect setValue={setCountry} readonly={readonly} selectedCode={countryValue} setCountryName={setCountryName} />
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className="form-group">
                        <label htmlFor="zip_code">Zipcode</label>
                        <TextField size="small" type="text" className="form-control" disabled={readonly} name="zip_code" value={zipCodeValue} onChange={(e) => setZipCode(e.target.value)} inputProps={{ maxLength: 50 }} />
                    </div>
                </Grid>
                <Grid item xs={5}>
                    <div className="form-group">
                        <label htmlFor="locality">Locality</label>
                        <TextField
                            size="small"
                            type="text"
                            className="form-control"
                            disabled={readonly && userType != 1 && userType != 2}
                            name="locality"
                            value={localityValue}
                            onChange={(e) => setLocality(e.target.value)}
                            inputProps={{ maxLength: 100 }}
                        />
                    </div>


                </Grid>
            </Grid>
            <Box sx={{ color: 'primary.main_light' }}>
                <Typography fontSize={17} fontWeight={'bold'} marginTop={3} align="left">
                    Files
                </Typography>
            </Box>

            <label htmlFor="passport">{center.currency == 1 ? 'Passport/eID Picture ' : 'Passport Picture '}</label>
            <Box sx={{ color: 'primary.main_light' }} align="left">
                {passportPicture ?
                    <div>
                        <Grid container>
                            <Grid item xs={12}>
                                {passportPicture.substring(passportPicture.indexOf("/") + 1, passportPicture.indexOf(";")) == 'pdf' || passportPicture.slice(-3) == "pdf" ?
                                    <Chip onClick={() => { downloadPassport() }}
                                        label={`${firstNameValue}${lastNameValue}_passport.pdf`} /> :

                                    <Avatar sx={{ height: "100px", width: "100px" }}>
                                        <img src={passportPicture} height={100} width={100} />
                                    </Avatar>
                                }
                            </Grid>
                            {!readonly &&
                                <Grid item xs={12} alignItems={"center"}>
                                    <IconButton variant="contained" component="label" onClick={() => { setPassportPicture(null) }} >
                                        <DeleteIcon />
                                    </IconButton >
                                </Grid>
                            }
                        </Grid>
                    </div>
                    :
                    <>
                        {!readonly &&
                            <>
                                <IconButton variant="contained" component="label">
                                    <Avatar sx={{ height: "100px", width: "100px" }}>
                                        <AddAPhotoIcon />
                                        <input type="file" hidden accept=".pdf,.png,.gif,.jpg,.jpeg" max={3 * 1024 * 1024} onChange={handlePassportPictureChange} />
                                    </Avatar>
                                </IconButton >
                                <br></br>
                                <Typography fontSize={10}>
                                    Allowed *.pdf, *.jpg, *.jpeg, *.png, *.gif
                                </Typography>
                                <Typography fontSize={10}>
                                    Max size of 3 MB
                                </Typography>
                            </>
                        }
                    </>
                }
                <br></br>
            </Box>
        </Paper>)
}

export default StudentDetails